import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import InvestmentDashboard from "@/components/InvestmentDashboard";
import NavBar from "@/components/NavBar";
import { Shield } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const { userRole } = useAuth();
  const navigate = useNavigate();

  const userName = 'Olá';
  return (
    <div className="min-h-screen bg-gradient-bg">
      <NavBar />

      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="mb-6 sm:mb-8 animate-fade-in">
          <div className="mb-4 sm:mb-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
              Bem-vindo de volta! 👋
            </h2>
            <p className="text-muted-foreground text-base sm:text-lg">
              {userRole === 'admin' 
                ? 'Gerencie as operações e configure as taxas da plataforma.'
                : 'Acompanhe seus investimentos e gerencie seus rendimentos de forma simples e segura.'
              }
            </p>
            {userRole === 'admin' && (
              <div className="mt-4">
                <Button 
                  onClick={() => navigate('/admin')}
                  className="bg-gradient-primary hover:opacity-90 transition-opacity w-full sm:w-auto"
                >
                  <Shield className="mr-2 h-4 w-4" />
                  Painel de Controle
                </Button>
              </div>
            )}
          </div>

          {/* Dashboard */}
          <div className="animate-slide-up">
            <InvestmentDashboard />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Index;